import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import TextWithReadMore from '../../Components/Readmore';
import API from '../../Api/Api';
import { IMAGE_PATHS } from '../../Functions/Constant';
import InfoTooltip from '../../Components/InfoTooltip';
import ConfirmationPopup from '../../Components/ConfirmationPopup';
import Confin from '../../Components/confin';

const About = ({ experienceRef , userData,showBuyAlert}) => {



   
    return (
        <section className="pb-[15px] px-4" ref={experienceRef}>
            {!showBuyAlert && (<Container>
                <Row>
                    <Col xs={12} md={12} className={`${((userData.profile_title == null || userData.profile_title == "") && (userData.about == null || userData.about == "")) ? "p-0" : ""}`}>
                        <div className={`flex justify-between items-baseline ${(!userData.profile_title && !userData.about) ? "bg-white rounded-lg p-6 border border-gray-200 shadow-lg" : ""}`}>
                            <div>
                                <h3 className={`text-[22px] font-bold text-gray-900 mb-2 leading-[1.4] ${(!userData.profile_title && !userData.about) ? "mt-1" : "mt-3"}`}>
                                    About <InfoTooltip text="Give a quick professional intro to help others understand your background." />
                                </h3>
                            </div>
                           
                        </div>
                    </Col>
                </Row>
                {(userData.profile_title != "" || userData.about != "") && (
                    <Row className="bg-white rounded-lg p-6 border-1 mb-4 !pr-[14px]">
                        <Col lg={11} md={10} sm={10} xs={10}>
                            <p className="text-gray-700 leading-[1.4]"><TextWithReadMore text={userData.about} /></p>
                        </Col>
                        
                    </Row>
                )}
            </Container>)}
            

        </section>
    );
};

export default About;